import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { heroData } from '../data/mock';

const Hero = ({ onCheckFlight }) => {
  return (
    <section 
      className="relative overflow-hidden bg-blue-50"
      style={{
        paddingTop: '180px',
        paddingBottom: '100px'
      }}
    >
      <div className="absolute inset-0 bg-grid-slate-100 [mask-image:linear-gradient(0deg,white,rgba(255,255,255,0.6))] -z-10" />
      
      {/* Subtle transition at bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-b from-transparent via-blue-50/20 to-blue-50/40 pointer-events-none" />
      <div 
        className="absolute bottom-0 left-0 right-0 h-24 opacity-[0.015] pointer-events-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' /%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' /%3E%3C/svg%3E")`,
          backgroundRepeat: 'repeat',
          backgroundSize: '128px 128px'
        }}
      />
      
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-medium">
              <CheckCircle2 className="w-4 h-4" />
              No Upfront Payment Required
            </div>
            
            <h1 
              className="text-5xl sm:text-6xl lg:text-[4rem] font-bold text-gray-900 leading-[1.1] tracking-tight"
              style={{ 
                maxWidth: '22ch',
                textWrap: 'balance',
                WebkitTextWrap: 'balance',
                MozTextWrap: 'balance'
              }}
            >
              Get Up To <span className="text-blue-600">€600</span> For Your Delayed Flight
            </h1>
            
            <p 
              className="text-lg sm:text-xl text-gray-600 leading-relaxed"
              style={{ 
                maxWidth: '75ch'
              }}
            >
              Our AI powered platform checks your eligibility<br className="hidden md:block" /><span className="md:hidden"> </span>and submits your claim automatically.<br className="hidden md:block" /><span className="md:hidden"> </span>You only pay if compensation is recovered.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 pt-2">
              <Button 
                size="lg" 
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-base font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                onClick={onCheckFlight}
              >
                Check My Flight
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
              
              <Button 
                size="lg" 
                variant="outline"
                className="border-2 border-gray-300 hover:border-blue-600 hover:text-blue-600 px-8 py-6 text-base font-semibold rounded-xl transition-all duration-300"
                onClick={() => document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' })}
              >
                How It Works
              </Button>
            </div>
            
            <div className="flex flex-wrap items-center gap-6 pt-4 text-sm text-gray-600">
              <div className="flex items-center gap-2">
                <CheckCircle2 className="w-5 h-5 text-green-600" />
                <span className="whitespace-nowrap">2 minute check</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle2 className="w-5 h-5 text-green-600" />
                <span className="whitespace-nowrap">95% success rate</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle2 className="w-5 h-5 text-green-600" />
                <span className="whitespace-nowrap">€250-€600 per passenger</span>
              </div>
            </div>
          </div>
          
          {/* Right Image with 3D effect */}
          <div className="relative lg:ml-4 group">
            <div className="absolute inset-0 bg-gradient-to-tr from-blue-600/20 to-transparent rounded-3xl transform rotate-3 transition-transform duration-300 group-hover:rotate-2" />
            <img 
              src={heroData.heroImage}
              alt="Flight delay compensation"
              className="relative rounded-3xl shadow-2xl w-full h-auto object-cover transition-transform duration-300 group-hover:translate-y-[-4px]"
              style={{
                transform: 'perspective(1000px) rotateY(-2deg)',
                transition: 'transform 0.3s ease'
              }}
            />
          </div>
        </div>
      </div>
      
      <style jsx>{`
        @media (max-width: 1024px) {
          section {
            padding-top: 96px !important;
            padding-bottom: 64px !important;
          }
        }
      `}</style>
    </section>
  );
};

export default Hero;
